<!-- Young -->
<template>
  <div class="doorPlate-equipment">
    <a-spin :spinning="rebootLoading" tip="设备正在重启中..." size="large">
      <public-bread-crumb :routes="routes" />
      <public-top-bar
        placeholder="请输入设备名称、版本号、SN码"
        :topBarBtns="topBarBtns"
        :onTableSearchFun="onTableSearchFun"
        @changeBasicSearchFun="changeBasicSearchFun"
      >
        <template #topBarLeft>
          <a-select
            placeholder="设备型号"
            class="top-bar-input"
            allowClear
            v-model="searchObj.deviceModel"
            @change="onTableSearchFun"
          >
            <a-select-option
              v-for="(i, index) in equipmentModel"
              :key="index"
              :value="i.id"
              >{{ i.value }}</a-select-option
            >
          </a-select>
        </template>
      </public-top-bar>

      <public-table
        rowKey="sn"
        :columns="columns"
        :tableData="tableData"
        :tableInfo="tableInfo"
        :tableLoading="tableLoading"
        @selectTableRowFun="selectTableRowFun"
        @sortChangeFun="tableSorterFun"
      >
        <!-- 设备状态 -->
        <template slot="state" slot-scope="scope">
          <span :style="{ color: scope.row.state ? '#333' : '#red' }">{{
            scope.row.state ? "在线" : "离线"
          }}</span>
        </template>
        <!-- 故障监测 -->
        <template slot="instruc" slot-scope="scope">
          <span
            :style="{
              color: scope.row.instruc ? 'red' : '#5862cb'
            }"
            >{{ scope.row.instruc ? "异常" : "正常" }}</span
          >
        </template>
      </public-table>
      <a-modal
        v-model="modalShow"
        title="选择升级包"
        width="660px"
        class="update-modal"
        centered
        :closable="false"
      >
        <public-update
          type="门牌设备"
          :updateServices="this.updateServices"
          :modalShow="modalShow"
          @closeUpdate="closeUpdate"
          @checkedVersion="checkedVersion"
        />
        <template slot="footer">
          <a-button
            key="back"
            type="primary"
            class="footer-btn"
            :loading="updateLoading"
            @click="updateMe"
            >确定</a-button
          >
          <a-button
            key="submit"
            @click="closeUpdate"
            class="footer-btn"
            style="margin-right: 0; background: #ecedff"
            >取消</a-button
          >
        </template>
      </a-modal>
      <public-status
        ref="statusWeight"
        :statusData="statusData"
        :statusType="statusType"
      />
    </a-spin>
    <!-- 延迟检测弹框 -->
    <a-modal
      v-model="delaydetectmod_modalShow"
      title="延迟监测"
      class="update-modal"
      width="460px"
      centered
      :closable="false"
    >
      <div class="ant-modal-body">
        <span style="line-height: 42px;">目标地址：</span>
        <a-input-search
          placeholder="请输入目标地址"
          enter-button="测试"
          @search="delaydetectmodSearchFun"
          v-model="delaydetectmod_testUrl"
        />
        <div class="delaydetectmod-test">
          <div v-if="delaydetectmod_test === 'test1'" style="color:#f00">
            此网络延迟的测试地址不可用
          </div>
          <div
            v-else-if="delaydetectmod_test === 'test2'"
            style="color:#31b520"
          >
            此地址可用
          </div>
          <div
            v-else-if="
              delaydetectmod_testUrl.length === 0 ||
                delaydetectmod_test === 'test3'
            "
            style="color:#aaa"
          >
            请输入目标地址
          </div>
          <div v-else-if="delaydetectmod_test === 'test4'" style="color:#aaa">
            测试中<a-spin style="margin-left: 5px;" />
          </div>
          <div v-else="delaydetectmod_test === 'test5'" style="color:#fff">
            请输入目标地址
          </div>
        </div>
      </div>
      <template slot="footer">
        <a-button
          key="submit"
          @click="closeDelaydetectmod"
          class="footer-btn"
          style="margin-right: 0; background: #ecedff"
          >取消</a-button
        >
        <a-button
          key="back"
          type="primary"
          class="footer-btn"
          :loading="delayupdateLoading"
          @click="delayupdateMe"
          :disabled="delaydetectmod_disabled"
          >确定</a-button
        >
      </template>
    </a-modal>
  </div>
</template>

<script>
import { devicePublic, publicTableList } from '@/mixins/mixinsData'
import doorSpace from '@/services/doorSpace.services'
import ACServices from '@/services/accessControl.services'
import DeviceServices from '@/services/deviceCommon.services'

export default {
  name: 'DoorPlateEquipment',
  mixins: [devicePublic, publicTableList],
  data () {
    return {
      statusType: false,
      delayupdateLoading: false,
      delaydetectmod_modalShow: false, // 延迟加载弹框标杆
      delaydetectmod_disabled: true, // 延迟加载弹框确认按钮禁用
      delaydetectmod_test: '', // 延迟加载弹框确认提示文字
      delaydetectmod_testUrl: '', // 延迟加载弹框地址
      topBarBtns: [
        {
          name: '版本升级',
          type: 'primary',
          fun: this.openUpdate
        },
        {
          name: '重启',
          type: 'primary',
          fun: this.restartDevice
        },
        {
          name: '全选',
          type: '',
          fun: this.selectAllFun
        },
        // {
        //   name: "重置",
        //   type: "primary",
        //   fun: this.resetSearchFun
        // },
        {
          name: '延迟监测修改',
          type: '',
          fun: this.delaydetectmodFun
        }
      ],
      routes: [
        {
          name: '门牌设备管理',
          path: '/door-plate-equipment'
        }
      ],
      equipmentModel: [
        { id: '0', value: '全部' },
        { id: '1', value: 'SpaceKeeper_1' }
      ],
      columns: [
        {
          title: '机构名称',
          dataIndex: 'areaName',
          type: 'tooltip', // 有气泡
          width: 220
        },
        {
          title: '门牌设备名称',
          dataIndex: 'name',
          width: 220,
          type: 'tooltip'
        },
        {
          title: '设备型号',
          dataIndex: 'deviceType',
          width: 165,
          type: 'tooltip'
        },
        {
          title: '设备状态',
          dataIndex: 'state',
          custom: true, // 自定义渲染文字
          width: 165
        },
        {
          title: '故障监测',
          dataIndex: 'instruc',
          fun: this.lookStatusFun,
          type: 'cellClick',
          custom: true,
          width: 165
        },
        {
          title: 'SN码',
          dataIndex: 'sn',
          width: 225,
          type: 'tooltip'
        },
        {
          title: '本地IP',
          dataIndex: 'ip',
          width: 194
        },
        {
          title: '版本号',
          dataIndex: 'version'
        }
      ]
    }
  },
  computed: {
    // 监听属性 类似于data概念
  },
  watch: {
    delaydetectmod_testUrl: {
      immediate: true,
      handler: function (val) {
        this.delaydetectmod_test = ''
        this.delaydetectmod_disabled = true
        if (val.length == 0) {
          this.delaydetectmod_test = 'test3'
        }
      }
    },
    delaydetectmod_modalShow: {
      immediate: true,
      handler: function (val) {
        if (!val) {
          this.delaydetectmod_disabled = true
        }
      }
    }
  },
  mounted () {
    // 获取门牌设备列表
    this.getTableData(doorSpace.GetSpaceEquListByPgae)

    // 故障状态Api
    this.statusServices = ''
    // 重启设备Api
    this.rebootServices = DeviceServices.RebootDevices

    // 升级Api
    this.updateServices = {
      listServices: DeviceServices.GetVersionTable,
      updateApi: DeviceServices.UpdateVersion
    }
  },
  methods: {
    // 版本升级弹窗
    openUpdate () {
      if (this.tableInfo.selectRows.length <= 0) {
        this.$message.warning('请选择需要升级的设备')
        return
      }
      let checktype = this.checkaddesstype(this.tableInfo.selectRowDate) //= ===>布尔值用于判断是否打开升级包弹框
      checktype
        ? this.$message.warning('请选中相同型号的设备')
        : (this.modalShow = true)
    },
    // 校验选择机构类型
    checkaddesstype (arr) {
      this.addesstype = arr[0].deviceType
      let checkaddesstype = arr.some((item, index) => {
        return item.deviceType !== this.addesstype
      })
      return checkaddesstype
    },
    // 延迟加载弹窗
    async delaydetectmodFun () {
      if (this.tableInfo.selectRows.length <= 0) {
        this.$message.warning('请选择需要修改的设备')
        return
      }
      let checktype = this.checkaddesstype(this.tableInfo.selectRowDate)
      if (checktype) {
        this.$message.warning('请选中相同型号的设备')
        return
      }
      let params = {
        address: '',
        list: this.tableInfo.selectRows
      }
      const { status, result } = await ACServices.GetDelayDetection(params)
      if (status === 0) {
        this.delaydetectmod_testUrl = result
        this.delaydetectmod_modalShow = true
      }
      this.delaydetectmod_test = 'test5'
    },
    // 延迟加载弹窗--取消
    closeDelaydetectmod () {
      this.delaydetectmod_modalShow = false
    },
    // 延迟加载弹窗--确定
    async delayupdateMe () {
      this.delayupdateLoading = true
      let params = {
        address: this.delaydetectmod_testUrl,
        list: this.tableInfo.selectRows
      }
      const { status, result } = await ACServices.SettingDelayDetection(params)
      this.delayupdateLoading = false

      if (status === 0) {
        this.delaydetectmod_modalShow = false
      }
    },
    // 延迟加载弹窗测试按钮
    async delaydetectmodSearchFun (value) {
      if (!value) {
        return
      }
      this.delaydetectmod_test = 'test4'
      // this.ping(value, this);
      let params = {
        address: value
      }
      const { status, result } = await ACServices.DelayDetection(params)
      if (status !== 0) {
        this.delaydetectmod_test = 'test1'
        return
      }
      if (result) {
        this.delaydetectmod_test = 'test2'
        this.delaydetectmod_disabled = false
      } else {
        this.delaydetectmod_test = 'test1'
        this.delaydetectmod_disabled = true
      }
    }
  }
}
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类

.doorPlate-equipment {
  .top-bar-input {
    margin-left: 24px;
    display: inline-block;
    width: 396px;
  }
}

.update-modal {
  height: 439px;
  .ant-modal-content {
    .ant-modal-header {
      height: 53px;
      padding: 16px 0;
      text-align: center;
    }
    .ant-modal-body {
      // height: 320px;
      padding: 16px 16px 0;
      .delaydetectmod-test {
        padding: 12px 0;
      }
    }
    .ant-modal-footer {
      height: 64px;
      padding: 16px;
      text-align: center;
    }
  }

  .changeTemperMode-body {
    padding: 0 16px 16px;
    box-sizing: border-box;
    .changeTemperMode-title {
      color: #000;
      font-weight: 500;
    }
    .changeTemperMode-main {
      .radio-row {
        span.ant-radio + * {
          width: 95%;
        }

        .upPackage-desc {
          color: #aaa;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .footer-btn {
    width: 88px;
    height: 32px;
    margin-right: 32px;
    border-radius: 3px;
    border: 0px;
  }
}
</style>
